<div class="admin-section-header" [class.collapsed]="divergentPricesCollapsed">
  <div
    [class.collapsed]="divergentPricesCollapsed"
    class="d-flex"
    (click)="divergentPricesCollapsed = !divergentPricesCollapsed"
  >
    <div>
      {{
        collaborative
          ? 'Prijsberekeningen gezamenlijke opdracht'
          : 'Afwijkende prijsberekeningen'
      }}
    </div>
    <div class="admin-section-arrow">
      <div>
        <button mat-icon-button>
          <mat-icon class="admin-section-arrow-icon">arrow_drop_up</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
<div [collapse]="divergentPricesCollapsed" [isAnimated]="!safari">
  <div class="collapse-content-container divergent-price-collapse-content">
    <div
      *ngIf="subProject.invoiceAsNonExecuted"
      class="strong invoice-as-non-executed-warning"
    >
      Deze opdracht is deels te factureren
    </div>
    <ng-container
      *ngIf="
        subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT;
        else adjustmentInvoicing
      "
    >
      <ip-board-invoicing
        [showTitle]="false"
        [baseProject]="baseProject"
        [collaborative]="collaborative"
        [showSave]="showSave"
        [savingLines]="savingLines"
        (save)="save.emit(subProject)"
        (saveLines)="saveLines.emit()"
        (divergentPricesChecked)="divergentPricesChecked.emit($event)"
        [class.p-top]="subProject.invoiceAsNonExecuted"
      ></ip-board-invoicing>
    </ng-container>
    <ng-template #adjustmentInvoicing>
      <ip-board-adjustment-invoicing
        [showTitle]="false"
        [adjustment]="subProject"
        [project]="project"
        [showSave]="showSave"
        [savingLines]="savingLines"
        (save)="save.emit(subProject)"
        (saveLines)="saveLines.emit()"
        (divergentPricesChecked)="divergentPricesChecked.emit($event)"
        [class.p-top]="subProject.invoiceAsNonExecuted"
      ></ip-board-adjustment-invoicing>
    </ng-template>
  </div>
</div>
